/**
* http://www.codrops.com
*
* Licensed under the MIT license.
* http://www.opensource.org/licenses/mit-license.php
* 
* Copyright 2019, Codrops
* http://www.codrops.com
*
* Modified By LiquidThemes
*/
(function ( $ ) {
	
	'use strict';
	
	const pluginName = 'liquidImageTrail';
	let defaults = {
		trigger: 'body',
		triggerRelation: null,
		imgArrayContainer: '.lqd-img-trail-array',
		threshold: 85,
		keepLastItemVisible: false,
		respectDirection: false
	};
	
	class Img {
		constructor(el) {
			this.DOM = {el: el};
			// image deafult styles
			this.defaultStyle = {
				scale: 1,
				x: 0,
				y: 0,
				opacity: 0
			};
			// get sizes/position
			this.getRect();
			// init/bind events
			this.initEvents();
		}
		initEvents() {
			// on resize get updated sizes/position
			window.addEventListener('resize', () => this.resize());
		}
		resize() {
			// reset styles
			gsap.set(this.DOM.el, {
				...this.defaultStyle
			});
			// get sizes/position
			this.getRect();
		}
		getRect() {
			this.rect = this.DOM.el.getBoundingClientRect();
		}
		isActive() {
			// check if image is animating or if it's visible
			return this.DOM.el.style.opacity != 0;
		}
	}
	
	class Plugin {
		
		constructor(element, options) {

			this.element = element;
			this.$element = $(element);
			
			this.options = $.extend({}, defaults, options);
			
			this._defaults = defaults;
			this._name = pluginName;

			// images container
			this.DOM = {
				imgArrayContainer: this.element.querySelector(this.options.imgArrayContainer)
			};
			// array of Image objs, one per image element
			this.images = [];
			[...this.DOM.imgArrayContainer.querySelectorAll('.lqd-img-trail-img')].forEach(img => this.images.push(new Img(img)));
			// total number of images
			this.imagesTotal = this.images.length;
			// upcoming image index
			this.imgPosition = 0;
			// zIndex value to apply to the upcoming image
			this.zIndexVal = 1;

			// mousePos: current mouse position
			// this.cacheMousePos: previous mouse position
			// this.lastMousePos: last last recorded mouse position (at the time the last image was shown)
			this.lastMousePos;
			this.cacheMousePos;
			this.mousePos = this.lastMousePos = this.cacheMousePos = {x: 0, y: 0};

			this.rAFId = null;
			
			const preloadImages = () => {
				return new Promise((resolve) => {
					imagesLoaded(this.DOM.imgArrayContainer.querySelector('.lqd-img-trail-img'), resolve);
				});
			};
			
			// And then..
			preloadImages().then(() => {
				// render the images
				this.initEvents();
				this.element.classList.add('img-trail-initiated');
			});

		}

		lerp(a, b, n) {
			return ( (1 - n) * a + n * b );
		}
		
		distance(x1,y1,x2,y2) {
			return Math.hypot(x2-x1, y2-y1);
		}

		// gets the distance from the current mouse position to the last recorded mouse position
		getMouseDistance () {
			return this.distance(this.mousePos.x,this.mousePos.y,this.lastMousePos.x,this.lastMousePos.y);
		}

		setThreshold(trigger) {

			if ( this.options.threshold === 'auto' ) {
				this.options.threshold = ($(trigger).outerWidth() / this.images.length - 1) / 1.75;
			}

		}

		initEvents() {

			let { trigger, triggerRelation } = this.options;

			if ( triggerRelation ) {
				trigger = this.$element[triggerRelation](trigger);
			}

			if ( trigger === 'this' ) {
				trigger = this.element;
			}

			this.setThreshold(trigger);

			// update the mouse position
			$(trigger).on('mouseenter', () => this.rAFId = requestAnimationFrame(this.render.bind(this)));
			$(trigger).on('mousemove', ev => {
				this.mousePos = liquidGetMousePos(ev, true)
			});
			$(trigger).on('mouseleave', () => cancelAnimationFrame(this.rAFId));

		}
		
		render() {

			// get distance between the current mouse position and the position of the previous image
			let distance = this.getMouseDistance();
			// cache previous mouse position
			this.cacheMousePos.x = this.lerp(this.cacheMousePos.x || this.mousePos.x, this.mousePos.x, 0.1);
			this.cacheMousePos.y = this.lerp(this.cacheMousePos.y || this.mousePos.y, this.mousePos.y, 0.1);
			
			// if the mouse moved more than [this.options.threshold] then show the next image
			if ( distance > this.options.threshold ) {
				
				++this.zIndexVal;

				if ( ! this.options.respectDirection || ( this.options.respectDirection && this.cacheMousePos.x < this.mousePos.x ) ) {
					this.imgPosition = this.imgPosition < this.imagesTotal - 1 ? this.imgPosition + 1 : 0;
				} else {
					this.imgPosition = this.imgPosition === 0 ? this.imagesTotal - 1 : this.imgPosition - 1;
				}

				this.showNextImage();
				
				this.lastMousePos = this.mousePos;
			}
			
			// check when mousemove stops and all images are inactive (not visible and not animating)
			let isIdle = true;
			for (let img of this.images) {
				if ( img.isActive() ) {
					isIdle = false;
					break;
				}
			}
			// reset z-index initial value
			if ( isIdle && this.zIndexVal !== 1 ) {
				this.zIndexVal = 1;
			}

			this.rAFId = requestAnimationFrame(this.render.bind(this));
		}

		showNextImage() {

			// show image at position [this.imgPosition]
			const img = this.images[this.imgPosition];
			// kill any tween on the image
			gsap.killTweensOf(img.DOM.el);

			img.DOM.el.style.zIndex = this.zIndexVal;

			gsap.timeline({
				onStart: () => {
					if ( this.options.keepLastItemVisible ) {
						this.images.forEach((image, i) => {
							if ( i !== this.images.indexOf(img) ) {
								gsap.killTweensOf(image.DOM.el);
								gsap.to(image.DOM.el, {
									opacity: 0,
									duration: 0.25,
									ease: 'expo.out'
								});
							}
						})
					}
				}
			})
			.set(img.DOM.el, {
					opacity: 1,
					scale: 1,
					zIndex: this.zIndexVal,
					x: this.cacheMousePos.x - img.rect.width/2,
					y: this.cacheMousePos.y - img.rect.height/2
			}, 0)
			.to(img.DOM.el, {
					ease: 'expo.out',
					duration: 0.9,
					x: this.mousePos.x - img.rect.width/2,
					y: this.mousePos.y - img.rect.height/2
			}, 0)
			.to(img.DOM.el, {
					ease: 'power1.out',
					duration: 1,
					opacity: this.options.keepLastItemVisible ? 1 : 0,
			}, 0.4);

		}
		
	}
	
	$.fn[ pluginName ] = function( options ) {
		
		return this.each( function() {
			
			const pluginOptions = {...$(this).data('img-trl-options'), ...options};
			
			if ( !$.data( this, "plugin_" + pluginName ) ) {
				$.data( this, "plugin_" + pluginName, new Plugin( this, pluginOptions ) );
			}
			
		} );
		
	};
	
}(jQuery));

jQuery(document).ready( function($) {
	$('[data-lqd-img-trail]').liquidImageTrail();
});